<!-- Admin-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>User Search</cs-header-title>
</cs-header>

<cs-content>
  <!-- Search Input -->
  <cs-input #searchInput autocomplete="off" id="search-text" [(value)]="searchText"
    type="text" name="searchText" inputmode="search" [placeholder]="'Type a user email...' | untranslated"
  [iconName]="showSpinner ? 'spinner' : 'search'" (input)="handleSearchChanged()"></cs-input>

  <!-- User Table. An empty search box shows no rows, whatever `filteredUsers` still holds: emptying
  the box supersedes the running search, but that search can already have published in the moment
  between the box being emptied and the 300ms debounce reaching the clear. Same test as the empty
  state below. -->
  @if (!showSpinner && searchText.length > 0 && filteredUsers.length > 0) {
    <cs-radio-group [(selected)]="selectedUserId">
      <cs-table class="user-table">
        @for (user of filteredUsers; track user) {
          <cs-table-row clickable
            (rowClick)="selectedUserId = user.couchUserInfo.name" [id]="user.couchUserInfo.name">
            <cs-table-cell class="radio-cell">
              <cs-radio [value]="user.couchUserInfo.name"></cs-radio>
            </cs-table-cell>
            <cs-table-cell class="info-cell">
              <div class="user-email">{{user.couchUserInfo.email}}</div>
              <div class="user-id">{{user.couchUserInfo.name}}</div>
            </cs-table-cell>
          </cs-table-row>
        }
      </cs-table>
    </cs-radio-group>
  }

  <!-- Empty state -->
  @if (!showSpinner && filteredUsers.length === 0 && searchText.length > 0) {
    <cs-empty-state
      [iconName]="searchErrorMessage ? 'warning' : 'search'" [title]="searchErrorMessage || ('No users found' | untranslated)">
    </cs-empty-state>
  }
</cs-content>

<cs-page-action-buttons>
  <cs-button secondary small [label]="'Impersonate' | untranslated"
  [disabled]="!selectedUserId" (click)="handleImpersonateButtonClick(getSelectedUser())"></cs-button>
  <cs-button secondary small [label]="'Permissions' | untranslated"
  [disabled]="!selectedUserId" (click)="handlePermissionsButtonClick(getSelectedUser())"></cs-button>
  <cs-button secondary small [label]="'Coach Slots' | untranslated"
  [disabled]="!selectedUserId" (click)="handleCoachSlotsButtonClick(getSelectedUser())"></cs-button>
  <cs-button primary small [label]="'Subscription' | untranslated"
  [disabled]="!selectedUserId" (click)="handleSubscriptionButtonClick(getSelectedUser())"></cs-button>
</cs-page-action-buttons>